import { request } from "services/request";

const resource = "api/documentAssignment";

const getFile = (id: number) => request(`${resource}/getFile/${id}`, { method: "GET" });

export { getFile };
